export default {
  covidAPI: 'https://corona.lmao.ninja/v2/countries',
  covidAPIDayBefore: 'https://coronavirus-19-api.herokuapp.com/countries/?yesterday=true',
  covidAPI_2: 'https://coronavirus-19-api.herokuapp.com/countries/',
  flagAPI: 'https://restcountries.eu/rest/v2/name/',
  flagURL: 'https://countryflagsapi.com/png/'
}
